import { Box, Container } from '@mui/material';

import { CupIcon } from '@/assets/icons/CupIcon.tsx';
import { CompetitionWinnersList } from '@/components/CompetitionWinnersList/index.ts';
import type { CompetitionWinner } from '@/lib/api/requests.ts';

import { Section } from '../_components/Section.tsx';

export const WinnersSection = (props: {
  winners: CompetitionWinner[] | undefined;
  month: 'juni' | 'juli';
}) => {
  if (!props.winners) {
    return null;
  }

  return (
    <Section>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center' }}>
          <CupIcon sx={{ mb: 2, marginInline: 'auto' }} />
          <h2 className="mx-auto mb-12 max-w-[30ch] typography-v1-h1 text-balance">
            Liste over vinnere som fikk sende gjelden sin på ferie i {props.month}
          </h2>
        </Box>
        <CompetitionWinnersList winners={props.winners} />
      </Container>
    </Section>
  );
};
